import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getShiftTankRecordList, updateShiftTankRecord } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import { formatTimeToStr } from '@/utils/date';
import * as imageConversion from 'image-conversion';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'ShiftTankRecord',
  components: {},
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      path: process.env.VUE_APP_BASE_API,
      listApi: getShiftTankRecordList,
      searchInfo: {
        stationId: '',
        tankNum: '',
        stationName: '',
        oilCode: ''
      },
      tableData: [],
      merge: [],
      // 存放需要合并的行
      mergeRowIndex: '',
      // 需要合并行下标
      updateMerge: [],
      // 存放需要合并的行
      updateMergeRowIndex: '',
      // 需要合并行下标
      page: 1,
      pageSize: 20,
      total: 0,
      stationOptions: [],
      stationTankOptions: [],
      stationTankOptionsTemp: [],
      dialogVisible: false,
      previewDialogVisible: false,
      previewDialogImageUrl: '',
      fullscreenLoading: false,
      updateTableData: [],
      formData: {
        stationId: 0,
        shiftNo: '',
        shiftOilHeight: 0,
        shiftWaterHeight: 0,
        shiftOilCapacity: 0,
        tankInNo: '',
        tankDataImg: '',
        tankNum: '',
        oilTankNo: '',
        oilCode: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var stationOptions, stationTankOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getStationBaseInfoList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 2:
              stationOptions = _context.sent;
              _this2.stationOptions = stationOptions.data.list;

              if (_this2.stationOptions.length > 0) {
                _this2.searchInfo.stationId = _this2.stationOptions[0].ID;
                _this2.searchInfo.stationName = _this2.stationOptions[0].stationName;
              }

              _context.next = 7;
              return getStationOilTankInfoList({
                page: 1,
                pageSize: 9999
              });

            case 7:
              stationTankOptions = _context.sent;
              _this2.stationTankOptions = stationTankOptions.data.list;

              _this2.onStationChange();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var page, pageSize, table;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this3.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this3.pageSize;
                _context2.next = 4;
                return _this3.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this3.searchInfo));

              case 4:
                table = _context2.sent;

                if (table.code === 0 && table.data.list != null) {
                  _this3.total = table.data.total;
                  _this3.page = table.data.page;
                  _this3.pageSize = table.data.pageSize;

                  _this3.getSpanArr(table.data.list);

                  _this3.tableData = table.data.list;

                  _this3.$forceUpdate();
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 20;

                if (_this4.searchInfo.stationId) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                if (_this4.searchInfo.tankNum) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                _context3.next = 8;
                return _this4.getTableData();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onReset: function onReset() {
      this.searchInfo = {
        stationId: '',
        tankNum: '',
        stationName: '',
        oilCode: ''
      };

      if (this.stationOptions.length > 0) {
        this.searchInfo.stationId = this.stationOptions[0].ID;
        this.searchInfo.stationName = this.stationOptions[0].stationName;
      }

      if (this.stationTankOptionsTemp.length > 0) {
        this.searchInfo.tankNum = this.stationTankOptionsTemp[0].tankNum;
        this.searchInfo.oilCode = this.stationTankOptionsTemp[0].oilCode;
      }

      this.onSubmit();
    },
    getSpanArr: function getSpanArr(data) {
      this.merge = [];
      this.mergeRowIndex = 0;

      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.merge.push(1);
          this.mergeRowIndex = 0;
        } else {
          if (data[i].shiftNo === data[i - 1].shiftNo) {
            this.merge[this.mergeRowIndex] += 1;
            this.merge.push(0);
          } else {
            this.merge.push(1);
            this.mergeRowIndex = i;
          }
        }
      }
    },
    tableCellMerge: function tableCellMerge(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;
      console.log('tableCellMerge');

      if (['shiftNo', 'shiftName', 'totalLastShiftLiters', 'totalOilSales', 'checkTotalLastShiftLiters', 'shiftOilHeight', 'shiftWaterHeight', 'shiftOilCapacity', 'cumulativeOilLossLiters', 'currentCumulativeOilLossLiters', 'tankDataImg'].includes(column.property)) {
        var _row = this.merge[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    getUpdateSpanArr: function getUpdateSpanArr(data) {
      this.updateMerge = [];
      this.updateMergeRowIndex = 0;

      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.updateMerge.push(1);
          this.updateMergeRowIndex = 0;
        } else {
          if (data[i].shiftNo === data[i - 1].shiftNo) {
            this.updateMerge[this.updateMergeRowIndex] += 1;
            this.updateMerge.push(0);
          } else {
            this.updateMerge.push(1);
            this.updateMergeRowIndex = i;
          }
        }
      }
    },
    updateTableCellMerge: function updateTableCellMerge(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;
      console.log('updateTableCellMerge');

      if (['shiftNo', 'shiftOilHeight', 'shiftWaterHeight', 'shiftOilCapacity', 'tankDataImg'].includes(column.property)) {
        var _row = this.updateMerge[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    onInputDecimal: function onInputDecimal(e) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
      this.$forceUpdate();
    },
    onExport: function onExport() {},
    // 分页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    onStationChange: function onStationChange() {
      var _this5 = this;

      this.stationTankOptionsTemp = this.stationTankOptions.filter(function (item) {
        return item.stationId == _this5.searchInfo.stationId;
      });
      this.stationOptionsTemp = this.stationOptions.filter(function (item) {
        return item.ID == _this5.searchInfo.stationId;
      });
      this.searchInfo.stationName = this.stationOptionsTemp[0].stationName;

      if (this.stationTankOptionsTemp.length > 0) {
        this.searchInfo.tankNum = this.stationTankOptionsTemp[0].tankNum;
        this.searchInfo.oilCode = this.stationTankOptionsTemp[0].oilCode;
      } else {
        this.searchInfo.tankNum = '';
        this.searchInfo.oilCode = '';
      }

      console.log('this.stationTankOptionsTemp', this.stationTankOptionsTemp);
      this.onSubmit();
    },
    onTankChange: function onTankChange() {
      var _this6 = this;

      var selTank = this.stationTankOptionsTemp.filter(function (item) {
        return item.tankNum == _this6.searchInfo.tankNum;
      });

      if (selTank && selTank.length > 0) {
        this.searchInfo.tankNum = selTank[0].tankNum;
        this.searchInfo.oilCode = selTank[0].oilCode;
      } else {
        this.searchInfo.tankNum = '';
        this.searchInfo.oilCode = '';
      }

      this.onSubmit();
    },
    // 上传预览
    handleUploadPreview: function handleUploadPreview(row, field) {
      this.previewDialogImageUrl = row[field];
      this.previewDialogVisible = true;
    },
    // 上传删除
    handleUploadRemove: function handleUploadRemove(row, field, ref) {
      row[field] = '';
      this.$refs[ref].clearFiles();
    },
    // 上传前校验图片
    uploadBefore: function uploadBefore(file) {
      // this.fullscreenLoading = true
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 < 800;

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!');
      }

      if (!isLt2M) {
        // 图片超过1M就压缩
        return new Promise(function (resolve, reject) {
          // 压缩到1M,这里的1024就是要压缩的大小,可自定义
          imageConversion.compressAccurately(file, 800).then(function (res) {
            resolve(res);
          }).catch(function (res) {
            console.error(res);
            reject(res);
          });
        });
      }

      return isPng || isJPG;
    },
    // 图片上传失败
    uploadError: function uploadError(err, file, fileList) {
      this.$message({
        type: 'error',
        message: '上传失败'
      });
      this.fullscreenLoading = false;
    },
    uploadSuccess: function uploadSuccess(res, file, fileList, row, field) {
      var that = this;
      this.fullscreenLoading = false;

      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        row[field] = this.path + '/' + res.data.file.url;
      } else {
        row[field] = res.data.file.url;
      }

      this.$forceUpdate();
    },
    onRowEdit: function onRowEdit(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getShiftTankRecordList({
                  'shiftNo': row.shiftNo,
                  'tankNum': row.tankNum,
                  'page': 1,
                  'pageSize': 99999
                });

              case 2:
                res = _context4.sent;

                _this7.getUpdateSpanArr(res.data.list);

                _this7.updateTableData = res.data.list;
                _this7.formData.stationId = row.stationId;
                _this7.formData.shiftNo = row.shiftNo;
                _this7.formData.shiftOilHeight = row.shiftOilHeight;
                _this7.formData.shiftWaterHeight = row.shiftWaterHeight;
                _this7.formData.shiftOilCapacity = row.shiftOilCapacity;
                _this7.formData.tankDataImg = row.tankDataImg;
                _this7.formData.oilCode = row.oilCode;
                _this7.formData.tankInNo = row.tankInNo;
                _this7.formData.tankNum = row.tankNum;
                _this7.formData.oilTankNo = row.oilTankNo;
                _this7.dialogVisible = true;

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onRowSubmit: function onRowSubmit(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                param = {
                  'stationId': row.stationId,
                  'shiftNo': row.shiftNo,
                  'tankNum': row.tankNum,
                  'oilTankNo': row.oilTankNo,
                  'status': 3
                };
                _context5.next = 3;
                return updateShiftTankRecord(param);

              case 3:
                res = _context5.sent;

                if (res.code == 0) {
                  _this8.$message.success('提交成功!');

                  _this8.getTableData();
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    dialogClose: function dialogClose() {
      this.dialogVisible = false;
      this.previewDialogVisible = false;
      this.previewDialogImageUrl = '';
      this.updateTableData = [];
      this.formData = {
        stationId: 0,
        shiftNo: '',
        shiftOilHeight: 0,
        shiftWaterHeight: 0,
        shiftOilCapacity: 0,
        tankDataImg: '',
        tankNum: '',
        oilTankNo: '',
        oilCode: ''
      };
      this.getTableData();
    },
    dialogSave: function dialogSave() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = JSON.parse(JSON.stringify(_this9.formData));
                param.shiftOilHeight = Number(param.shiftOilHeight);
                param.shiftWaterHeight = Number(param.shiftWaterHeight);
                param.shiftOilCapacity = Number(param.shiftOilCapacity);
                param.tankNum = Number(param.tankNum);
                param.oilCode = Number(param.oilCode);
                param.status = 2;
                param.oilTankShiftDataDetailList = [];

                _this9.updateTableData.forEach(function (item) {
                  param.oilTankShiftDataDetailList.push({
                    'ID': item.ID,
                    'giveInCompareLiters': Number(item.giveInCompareLiters)
                  });
                });

                _context6.next = 11;
                return updateShiftTankRecord(param);

              case 11:
                res = _context6.sent;

                if (res.code == 0) {
                  _this9.dialogVisible = false;
                }

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};